import { Card, FormLayout } from '@shopify/polaris'

import { getTranslation } from '../util/getTranslation'
import { FormTextField } from './FormTextField'

type TProps = {
  emailRequired?: boolean
}

export function SettingsContactCard({ emailRequired = false }: TProps) {
  return (
    <Card.Section>
      <FormLayout>
        <FormTextField
          name="contactEmail"
          label={`${getTranslation('common.contact_email')}${emailRequired ? ' * ' : ''}`}
          helpText={
            emailRequired
              ? undefined
              : getTranslation('common.contact_email_help')
          }
          autoComplete="email"
          required={emailRequired}
        />
        <FormTextField
          name="contactPhone"
          label={getTranslation('common.contact_phone')}
          helpText={getTranslation('common.contact_phone_help')}
          autoComplete="tel"
          required={false}
        />
      </FormLayout>
    </Card.Section>
  )
}
